import { fmtDate } from "@/lib/format";

export const REQ_KINDS = { accesso: "Accesso ai dati", rettifica: "Rettifica", cancellazione: "Cancellazione", limitazione: "Limitazione", portabilita: "Portabilità", opposizione: "Opposizione" };
export const REQ_STATUS = { aperta: ["Aperta", "bg-amber-100 text-amber-900"], in_lavorazione: ["In lavorazione", "bg-sky-100 text-sky-900"], evasa: ["Evasa", "bg-emerald-50 text-emerald-800"], respinta: ["Respinta", "bg-slate-200 text-slate-700"] };

export const ReqStatus = ({ r, testId }) => {
  const [l, c] = REQ_STATUS[r.status];
  return <span className={`whitespace-nowrap px-1.5 py-0.5 text-[11px] font-semibold uppercase ${c}`} data-testid={testId}>{l}</span>;
};

export const DueLeft = ({ r }) => (
  <span className={`font-mono text-xs ${r.days_left != null && r.days_left < 0 ? "font-bold text-red-700" : r.days_left != null && r.days_left <= 7 ? "font-semibold text-amber-700" : ""}`}>
    {fmtDate(r.due_on)}{r.days_left != null && <span className="ml-2">{r.days_left < 0 ? `scaduta da ${-r.days_left} gg` : `${r.days_left} gg`}</span>}
  </span>
);
